/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: aukbrhkegRkQ6KizvhdUPT
// Component: 93uVZfRMCA

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import Button from "../../components/widgets/Button"; // plasmic-import: SEF-sRmSoqV5c/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: aukbrhkegRkQ6KizvhdUPT/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../PP__plasmickit_left_pane.module.css"; // plasmic-import: aukbrhkegRkQ6KizvhdUPT/projectcss
import sty from "./PlasmicFilterButton.module.css"; // plasmic-import: 93uVZfRMCA/css

import FilterIcon from "../plasmic_kit_design_system/icons/PlasmicIcon__Filter"; // plasmic-import: F0M2GWyw-k/icon
import ArrowRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowRightSvg"; // plasmic-import: 9Jv8jb253/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon

createPlasmicElementProxy;

export type PlasmicFilterButton__VariantMembers = {
  isActive: "isActive";
};
export type PlasmicFilterButton__VariantsArgs = {
  isActive?: SingleBooleanChoiceArg<"isActive">;
};
type VariantPropType = keyof PlasmicFilterButton__VariantsArgs;
export const PlasmicFilterButton__VariantProps = new Array<VariantPropType>(
  "isActive"
);

export type PlasmicFilterButton__ArgsType = {};
type ArgPropType = keyof PlasmicFilterButton__ArgsType;
export const PlasmicFilterButton__ArgProps = new Array<ArgPropType>();

export type PlasmicFilterButton__OverridesType = {
  root?: Flex__<typeof Button>;
};

export interface DefaultFilterButtonProps {
  isActive?: SingleBooleanChoiceArg<"isActive">;
  className?: string;
}

const $$ = {};

function PlasmicFilterButton__RenderFunc(props: {
  variants: PlasmicFilterButton__VariantsArgs;
  args: PlasmicFilterButton__ArgsType;
  overrides: PlasmicFilterButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isActive",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isActive,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <Button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames("__wab_instance", sty.root, {
        [sty.rootisActive]: hasVariant($state, "isActive", "isActive"),
      })}
      color={hasVariant($state, "isActive", "isActive") ? "green" : undefined}
      endIcon={
        <ChevronDownSvgIcon
          className={classNames(projectcss.all, sty.svg__ydByj, {
            [sty.svgisActive__ydByjpuhxi]: hasVariant(
              $state,
              "isActive",
              "isActive"
            ),
          })}
          role={"img"}
        />
      }
      font={"dim"}
      size={"compact"}
      startIcon={
        <ArrowRightSvgIcon
          className={classNames(projectcss.all, sty.svg__h6NCv)}
          role={"img"}
        />
      }
      type={hasVariant($state, "isActive", "isActive") ? [] : ["clear"]}
      withIcons={["endIcon"]}
    >
      <FilterIcon
        className={classNames(projectcss.all, sty.svg__wHz3V, {
          [sty.svgisActive__wHz3Vpuhxi]: hasVariant(
            $state,
            "isActive",
            "isActive"
          ),
        })}
        role={"img"}
      />
    </Button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFilterButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFilterButton__VariantsArgs;
    args?: PlasmicFilterButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicFilterButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicFilterButton__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFilterButton__ArgProps,
          internalVariantPropNames: PlasmicFilterButton__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicFilterButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFilterButton";
  } else {
    func.displayName = `PlasmicFilterButton.${nodeName}`;
  }
  return func;
}

export const PlasmicFilterButton = Object.assign(
  // Top-level PlasmicFilterButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicFilterButton
    internalVariantProps: PlasmicFilterButton__VariantProps,
    internalArgProps: PlasmicFilterButton__ArgProps,
  }
);

export default PlasmicFilterButton;
/* prettier-ignore-end */
